export const MORE_ITEMS = 'MORE_ITEMS';
export const ITEM_DETAILS = 'ITEM_DETAILS';
export const ABOUT_SELLER = 'ABOUT_SELLER';

export const labelMap: Record<string, string> = {
    [MORE_ITEMS]: MORE_ITEMS,
    [ITEM_DETAILS]: ITEM_DETAILS,
    //story telling modules
    'iconic design': 'ABOUT_DESIGN',
    creator: 'ABOUT_DESIGNER',
    [ABOUT_SELLER]: ABOUT_SELLER,
};
